import { createChatStore } from '@edwin/cometchat'

export const useChatsStore = createChatStore()

export default useChatsStore
